import * as Views from "./views";

const Module = {
    name: "campaignoperator",
    defaultRoutePath: "/operator/campaignoperator",
    menuItemScope: "operator",
    menuItemName: "campaignOperator",

    routes: [
        {
            path: "/operator/campaignoperator",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                }
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "detail",
            Component: Views.Detail,
        }
    ],

}

export default Module;
